<template>
  <div>
    <div>
      <center>
        <h1>Incident Map</h1>
        <p>{{mapDiscription}}</p>
      </center>
    </div>
    <hr>
    <v-btn @click="goBack()" class="ma-2" color="primary" text><v-icon darkleft>mdi-arrow-left</v-icon>Back</v-btn>
    <v-btn @click="getIncidents()" class="ma-2" color="primary" text><v-icon darkleft>mdi-refresh</v-icon>REFRESH</v-btn>
    <center>
      <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
    </center>
    <div id="mapDiv">
      <GmapMap :center="mapCenter" :zoom='mapZoomLevel' :style="'width:100%; height: 80vh;'">
    <GmapMarker
        v-for="(m, index) in markers"
        :key="index"
        :position="m.position"
        :clickable="true"
        :draggable="false"
        @click="openInfoWindowTemplate(index)"
    />
    <gmap-info-window :options="{maxWidth: 300, pixelOffset: { width: 0, height: -35 }}" :position="infoWindow.position" :opened="infoWindow.open" @closeclick="infoWindow.open=false">
        <!-- <div v-html="infoWindow.template"></div> -->
        <div class="incident_map_details">
          <h2>{{selectedMarkerDetails.type}}</h2> 
          <br> 
          <h3>{{selectedMarkerDetails.address}}</h3>
          <br> 
          <h3>{{selectedMarkerDetails.municipality}}</h3>
          <br>
          <h3>{{selectedMarkerDetails.time}}</h3>
          <br>
          <router-link :to="{path: 'incident', query: {incidentID: selectedMarkerDetails.incidentID}}">
            <v-btn elevation="2" small>Details</v-btn>
          </router-link>
        </div>
    </gmap-info-window>
     </GmapMap>
    </div>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show" timeout="3000">
      {{ snackbar.message }} 
      <v-btn text @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>

export default {
  data: () => ({
    loading: false,
    incidents: [],
    servicesArray: [],
    areaSupported: [],
    areaIDarray: [],
    selectedService: "All",
    selectedArea: null,
    dateSelected: "2021-01-16",
    minDate: "2021-01-02",
    maxDate: "2021-01-16",
    mapCenter: { lat: 40.0379, lng: -76.3055 },
    mapZoomLevel: 10,
    markers: [],
    selectedMarkerDetails: {},
    mapDiscription: null,
    infoWindow: {
      position: {lat: 0, lng: 0},
      open: false,
      template: ''
    },
    snackbar: {
      show: false,
      message: null,
      color: "primary",
    }
  }),
  name: 'App',

  components: {
  },

  async created(){
    if (!localStorage.username){
      localStorage.removeItem('token');
      this.$router.push('login');
      return
    }
    if (!this.$route.query.area){
      this.$router.push({path: 'all-incidents-search'});
      return
    }
    const areaID = this.$route.query.area

    this.getMapSettings(areaID);
    this.getIncidents()

    //DYNAMIC MAP UPDATE
    // this.$nextTick(function () {
    //     window.setInterval(() => {
    //         this.getIncidents(area, date, service);
    //     },60000);
    // })
  },
  methods: {
    error(message){
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = "error";
    },
    goBack(){
      history.back();
    },
    async getIncidents(){
      this.loading = true;

      if (!this.$route.query.area){
        this.$router.push({path: 'all-incidents-search'});
        return
      }
      const areaID = this.$route.query.area

      if (!this.$route.query.date){
        this.$router.push({path: 'all-incidents-search'});
        return
      }
      let dateSelected = this.$route.query.date

      if (!this.$route.query.service){
        this.$router.push({path: 'all-incidents-search'});
        return
      }
      const selectedService = this.$route.query.service

    if (dateSelected == 'today'){
      this.mapDiscription = `${selectedService} Incidents Today`
    } else {
      this.mapDiscription = `${selectedService} Incidents on ${dateSelected}`
    }

      if (dateSelected == 'today'){
          const today = new Date();
          const dateDay = String(today.getDate()).padStart(2, "0");
          const dateMonth = String(today.getMonth() + 1).padStart(2, "0");
          const dateYear = today.getFullYear();

          dateSelected = dateYear + '-' + dateMonth + '-' + dateDay;
      }
      if (localStorage.paid_user != 'true'){
       if (localStorage.areaID != areaID){
         this.loading = false;
         this.$router.push({path: 'all-incidents-search'});
         return
       }
      }
      const incidentsResponse = await fetch(`${localStorage.apiURL}/app/incidents/${areaID}/${dateSelected}/${selectedService}/map`, {
        method: "GET",
        headers: {"deviceID": localStorage.token, "tokenID": localStorage.tokenID}
      });

      if (!incidentsResponse.ok){
        this.loading = false;
        this.error(`Returned a ${incidentsResponse.status}`);
        return;
      }

      const incidentsData = await incidentsResponse.json();

      if (!incidentsData.success){
        this.loading = false;
        this.error(`an error occured '${incidentsData.msg}'`);
        return
      }

      if (incidentsData.incidents.length === 0){
        this.loading = false;
        this.error("No incidents found")
      }
      if (this.incidents != incidentsData.incidents){
        this.incidents = null;
        this.incidents = incidentsData.incidents;
      }

      this.loading = false;
      this.markers = [];

      let i;
      for (i = 0; i < this.incidents.length; i++) {
          let latFloat = parseFloat(this.incidents[i].lat);
          let lngFloat = parseFloat(this.incidents[i].lng);
          
          if (!this.markers.includes({position: {lat: latFloat, lng: lngFloat}})){
            this.markers.push({position: {lat: latFloat, lng: lngFloat}
          });
        }
      }
    },
    openInfoWindowTemplate(index) {
        this.infoWindow.position = { lat: this.markers[index].position.lat, lng: this.markers[index].position.lng }

        this.selectedMarkerDetails = {
          incidentID: this.incidents[index].incidentID,
          type: this.incidents[index].type,
          address: this.incidents[index].address,
          municipality: this.incidents[index].municipality,
          time: this.incidents[index].time_created 
        }
        this.infoWindow.open = true
    },
    async getMapSettings(area){
      if (area == "10"){
        this.mapCenter = { lat: 40.0379, lng: -76.3055 };
        this.mapZoomLevel = 9; 
      } else if (area == "11"){
        this.mapCenter = { lat: 40.3685019, lng: -76.4851422 };
        this.mapZoomLevel = 10;
      } else if (area == "14"){
        this.mapCenter = { lat: 40.7227625, lng: -76.2234807 };
        this.mapZoomLevel = 10;
      } else {
        this.mapCenter = { lat: 40.7066284, lng: -76.6919848 };
        this.mapZoomLevel = 9; 
      }
    }
  },
};
</script>

<style scoped>
.watchlistItems{
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 10px;
}
.watchlistItems:hover{
  background-color: rgb(209, 209, 209);
}

p{
  margin: 0;
}
.selectors{
  margin-top: 35px;
  width: 350px;
}
.calendar{
  margin-top: 50px;
}
#continueButton{
  margin-bottom: 10%;
}
</style>
